import { STORES, idbClear } from "./db"
import { clearImageCaches } from "./imageCache"
import { clearOutbox } from "./outbox"
import { clearSnapshotRecords } from "./snapshotStore"

// Removes everything the device holds for the signed-in account.
export async function clearOfflineData() {
  await Promise.all([
    clearSnapshotRecords(),
    clearOutbox(),
    clearImageCaches(),
    idbClear(STORES.META)
  ])
}
